import { defineComponent, PropType } from "vue";

import { EmployeePreferenceEnum } from "../../../enums/EmployeePreferenceEnum";

export interface ISelectDropDownOption {
    [groupText: string]: IDropdownSelectOption[];
}

export interface IDropdownSelectOption {
    displayText: string;
    value: any;
    id?: string;
    icons?: string;
    relationshipIcons?: string;
    relationship?: number;
}

export default defineComponent({
    props: {
        dropDownOptions: { type: Object as PropType<ISelectDropDownOption>, default: {} },
        dropdownList: { type: Array, default: [] as IDropdownSelectOption[] },
        selectedOption: { type: String, default: "" },
        selectedText: { type: String, default: "" },
        selectedValue: { type: String, default: "" },
        labelText: { type: String, default: "" },
        selectedId: { type: Number },
        showIcons: { type: Boolean, default: false },
        isList: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false }
    },

    emits: ["updateSelectFields"],

    data() {
        return {
            filteredOptions: {} as ISelectDropDownOption,
            filteredList: [] as IDropdownSelectOption[],
            search: "" as string,
            EmployeePreferenceEnum
        };
    },

    mounted() {
        this.filteredOptions = { ...this.dropDownOptions };
        this.filteredList = [...this.dropdownList] as IDropdownSelectOption[];
        this.$emit("updateSelectFields", this.selectedValue ?? "", this.selectedText ?? "", null);
        $(this.$refs.dropDownMenu).on("click", (e) => {
            e.stopPropagation();
        });
        $(this.$refs.dropDownElement).on("shown.bs.dropdown", (e) => {
            (this.$refs.searchInput as HTMLInputElement).focus();
        });
    },

    computed: {
        getButtonText(): string {
            if (!this.selectedText) {
                return `Select ${this.labelText}`;
            } else {
                return `${this.selectedText}`;
            }
        },

        getSearchPlaceholder(): string {
            return `Search for ${this.labelText}`;
        },

        getDropDownOptionsLength() {
            this.filteredOptions = { ...this.dropDownOptions };
            return Object.values(this.dropDownOptions).reduce((len, option) => option.length + len, 0);
        },

        hasGroupLabel() {
            return Object.keys(this.dropDownOptions).length ? true : false;
        }
    },

    watch: {
        search() {
            if (this.search && !this.isList) {
                for (let groupName of Object.keys(this.dropDownOptions)) {
                    let options = this.dropDownOptions[groupName];
                    this.filteredOptions[groupName] = options.filter((option) =>
                        option.displayText.toLowerCase().includes(this.search.toLowerCase())
                    );
                }
            } else if (!this.search && !this.isList) {
                this.filteredOptions = { ...this.dropDownOptions };
            } else if (this.search && this.isList) {
                this.filteredList = (this.dropdownList as IDropdownSelectOption[]).filter((option) => {
                    return option.displayText.toLowerCase().includes(this.search.toLowerCase());
                }) as IDropdownSelectOption[];
            } else {
                this.filteredList = [...this.dropdownList] as IDropdownSelectOption[];
            }
        }
    },

    methods: {
        closeDropDown(option?: IDropdownSelectOption) {
            this.$emit("updateSelectFields", option?.value, option?.displayText, option?.id);
            $(this.$refs.dropDownElement).dropdown("toggle");
        }
    }
});
